import { filterValueToQuery } from '@/api';

export default function address(axios: any) {
  async function getProvinces(filter: any) {
    try {
      const response = await axios.get(`/api/provinces?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/address] getProvinces Error', e);
    }
    return null;
  }

  async function getDistricts(filter: any) {
    try {
      const response = await axios.get(`/api/districts?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/address] getDistricst Error', e);
    }
    return null;
  }

  async function getSubdistricts(filter: any) {
    try {
      const response = await axios.get(`/api/subdistricts?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/address] getSubdistricts Error', e);
    }
    return null;
  }

  return {
    getProvinces,
    getDistricts,
    getSubdistricts,
  };
}
